var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"poster-stack"},[(_vm.title.content.posterUrl)?_c(_setup.PictureComp,{staticClass:"poster",attrs:{"alt":"Silo","image-url":_vm.title.content.posterUrl,"image-profile":"poster_global"}}):_vm._e(),_c('div',{staticClass:"poster"}),_c('div',{staticClass:"poster"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }